"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sortClientCreatedAt = void 0;
const operators_1 = require("rxjs/operators");
const rxjs_1 = require("rxjs");
const toolbox_1 = require("@streem/toolbox");
/**
 * Sorts an observable array of WallItems in descending order based on the clientCreatedAt value.
 */
function sortClientCreatedAt() {
    return (0, rxjs_1.pipe)((0, operators_1.map)((items) => items.sort((a, b) => {
        if (!b.clientCreatedAt || !a.clientCreatedAt) {
            return -1;
        }
        (0, toolbox_1.invariant)(a.clientCreatedAt.seconds, 'WallItem must define when it was created at in seconds');
        (0, toolbox_1.invariant)(b.clientCreatedAt.seconds, 'WallItem must define when it was created at in seconds');
        return b.clientCreatedAt.seconds.sub(a.clientCreatedAt.seconds).toNumber();
    })));
}
exports.sortClientCreatedAt = sortClientCreatedAt;
//# sourceMappingURL=sort_client_created_at.js.map